'use client';

var styles = {"container":"Toast-module_container__2Bybb","toast":"Toast-module_toast__2oDAM","toast-in-right":"Toast-module_toast-in-right__1CJZe","title":"Toast-module_title__5tkl9","messageContainer":"Toast-module_messageContainer__6GBY3","message":"Toast-module_message__2WJDC","checkIcon":"Toast-module_checkIcon__3p179","errorIcon":"Toast-module_errorIcon__1V8Wg","closeIcon":"Toast-module_closeIcon__U9tgH"};

export { styles as default };
//# sourceMappingURL=Toast.module.css.js.map
